export default __webpack_public_path__ + "static/media/Libfic.70b42f04.png";